<template>
    <div v-if="pilha.length != 0">      
      <div class="preloader-wrapper small active">
        <div class="spinner-layer">
          <div class="circle-clipper left">
            <div class="circle"></div>
            </div><div class="gap-patch">
            <div class="circle"></div>
            </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    name:'spinner-loader',
    props: {
        pilha:{type:Array, required:true}
    },
    data() {
        return {
        }
    }    
}
</script>


// WEBPACK FOOTER //
// SpinnerLoader.vue?73b2b3f6